import state from '../state';
import type { ContentForDevice } from '../types';

export function getViewportValue<T>(config: ContentForDevice<T>, property?: undefined, isMobileViewport?: boolean): T;
export function getViewportValue<T>(
  config: ContentForDevice<T>,
  property: keyof T,
  isMobileViewport?: boolean,
): T[keyof T];
export function getViewportValue<T>(
  config: ContentForDevice<T>,
  property?: keyof T,
  isMobileViewport?: boolean,
): T | T[keyof T] {
  if (!config) return;

  const isMobile = isMobileViewport !== undefined ? isMobileViewport : state.isMobileViewport;
  const valueForViewport = isMobile ? config.mobile ?? config.computer : config.computer;
  return property ? valueForViewport[property] : valueForViewport;
}
